import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.get("https://anltcs.noorride.com/login", {
        auth: { username, password },
      });

      if (response.status === 200) {
        localStorage.setItem("isAuthenticated", "true");
        navigate("/dashboard"); // Redirect to Dashboard
      }
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Driver Management Dashboard</h1>
      <div style={styles.loginBox}>
        <h2 style={styles.heading}>Login</h2>
        <form onSubmit={handleLogin} style={styles.form}>
          <label style={styles.label}>Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            style={styles.input}
          />
          <label style={styles.label}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />
          <button type="submit" style={styles.button}>Login</button>
        </form>
        {error && <p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
};

// **Updated Styles - Labels in White**
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    background: "linear-gradient(135deg, #002855, #004d40)", // Deep blue-green gradient
    color: "white",
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "20px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    textShadow: "2px 2px 5px rgba(0,0,0,0.3)",
    color: "#fff", // <-- Make text white
},
  loginBox: {
    background: "rgba(255, 255, 255, 0.1)", // Glass effect
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
    width: "320px",
    textAlign: "center",
    backdropFilter: "blur(10px)", // Glassmorphism effect
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },
  heading: {
    marginBottom: "15px",
    fontSize: "24px",
    fontWeight: "600",
    color: "#fff", // <-- Make text white
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Align labels left
  },
  label: {
    color: "white", // **Labels are white**
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "5px",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "12px",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    background: "rgba(255, 255, 255, 0.2)", // Slight transparent effect
    color: "white", // **White text**
    outline: "none",
    textAlign: "center", // **Center text**
    fontWeight: "bold",
    "::placeholder": { color: "rgba(255, 255, 255, 0.6)" }, // **White placeholder**
  },
  button: {
    backgroundColor: "#00C853", // Vibrant green
    color: "white",
    padding: "12px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "bold",
    transition: "0.3s",
    width: "100%",
    marginTop: "10px",
  },
  error: {
    color: "#FF5252",
    marginTop: "12px",
  },
};

export default Login;
